import { faBug } from '@fortawesome/pro-regular-svg-icons';
import Button from '@sharedComponents/Button';
import ErrorMessage from '@sharedComponents/Error';
import FlexBox from '@sharedComponents/FlexBox';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';

// Route-level error page (react-router `errorElement`), replacing react-router's default developer screen
// whenever a BO route throws while rendering. "Reload the app" restarts the SPA from the BO home page.
const ErrorPage = () => {
    const { t } = useTranslation('bo');
    const error = useRouteError();

    // A thrown Error prints as "TypeError: …"; a thrown router response only carries its status text.
    const code = error instanceof Error ? error.toString() : (error?.statusText ?? '');

    return (
        <FlexBox flexDirection="column" alignItems="center" gap="m" additionnalStyles={{ padding: 'var(--space-xl)' }}>
            <ErrorMessage icon={faBug} message={t('A significant error has occurred.')} code={code} />
            <Button label={t('Reload the app')} theme="primary" action={() => window.location.assign(import.meta.env.BASE_URL)} />
        </FlexBox>
    );
};

export default ErrorPage;
